<template>
  <v-layout>
    <v-row class="bkgd-black">
      <v-col cols="12" md="12">
        <v-container class="width-override">
          <v-row>
            <v-col cols="12" md="12">
              <formbuilder />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import formbuilder from '@/components/formbuilder.vue'

export default {
  name: 'FormBuilder',
  components: {
    formbuilder
  }
}
</script>